interface TranslationHelperProps {
  langs: TranslationsWithDefault<TranslateFunction>;
  locale?: Locale;
  args?: any;
}

export class TranslationHelper {
  args: any;
  langs: TranslationsWithDefault<TranslateFunction>;
  translations: object;

  constructor({ langs, args, locale = 'default' }: TranslationHelperProps) {
    if (!langs.default) {
      throw new Error(
        `TranslationHelper(...): expects a default key in the language object`
      );
    }

    this.args = args;
    this.langs = langs;

    this.translations = (this.langs[locale] || this.langs.default)(this.args);
  }

  public useLocale(locale: Locale = 'default') {
    this.translations = (this.langs[locale] || this.langs.default)(this.args);
  }

  public get(key: string): string {
    return (this.translations as any)[key];
  }
}
